module.exports = __webpack_public_path__ + "img/box_pro_five_1.6b7bdaf0.jpg";